export const PROGRESSION_MODEL = {
  ID: 'id',
  KEY: 'key',
  TITLE: 'title',
  URL: 'url',
  ASSIGNEES: 'assignees',
  LAST_ACTIVITY: 'last_activity',
  STATUS: 'delivery_status',
  PROGRESS: 'progress',
  PARENT: 'parent'
};

export const PROGRESSION_TABLE_MODEL = {
  KEY_CELL: 'key_cell',
  TITLE_CELL: 'title_cell',
  ASSIGNEES_CELL: 'assignees_cell',
  LAST_ACTIVITY_CELL: 'last_activity_cell',
  PROGRESS_CELL: 'progress_cell',
  TOTAL_CELL: 'total_cell',
  STATUS_CELL: 'status_cell',
  PARENT_CELL: 'parent_cell',
  INSIGHTS_CELL: 'insights_cell'
};

export const PROGRESSION_PARENT_MODEL = {
  ...PROGRESSION_MODEL,
  TOTAL: 'issues',
  CHILDREN: 'children'
};

export const PROGRESSION_CHILD_MODEL = {
  ...PROGRESSION_MODEL,
  ASSIGNEE: 'assignee',
  TOTAL: 'story_points',
  INSIGHTS: 'insights'
};
